var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingA(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 615.292,
    height: 849.757,
    viewBox: "0 0 615.292 849.757",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3",
    d: "M307.646 0.5C392.4 0.500182 469.174 47.9433 524.779 124.737C580.384 201.531 614.792 307.645 614.792 424.878C614.792 542.111 580.384 648.226 524.779 725.02C469.174 801.813 392.4 849.257 307.646 849.257C222.893 849.257 146.118 801.814 90.5127 725.02C34.908 648.226 0.5 542.111 0.5 424.878C0.500072 307.645 34.908 201.531 90.5127 124.737C146.118 47.9431 222.893 0.5 307.646 0.5Z",
    stroke: "url(#paint0_linear_0_86)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_86",
    x1: 307.646,
    y1: 0,
    x2: 307.646,
    y2: 849.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    style: {
      stopColor: "#D9D9D9",
      stopColor: "color(display-p3 0.8510 0.8510 0.8510)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    style: {
      stopColor: "#161616",
      stopColor: "color(display-p3 0.0863 0.0863 0.0863)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingA);
export default __webpack_public_path__ + "static/media/ring-a.72be4b65649ecb7e333d8914adead935.svg";
export { ForwardRef as ReactComponent };